/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VipDiscountUpdateRequest } from '../../models/vip-discount-update-request';

export interface UpdateVipDiscount$Params {
  vipDiscountId: string;
      body: VipDiscountUpdateRequest
}

export function updateVipDiscount(http: HttpClient, rootUrl: string, params: UpdateVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateVipDiscount.PATH, 'put');
  if (params) {
    rb.path('vipDiscountId', params.vipDiscountId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateVipDiscount.PATH = '/discounts/vip/{vipDiscountId}';
